import { plusIcon } from '@progress/kendo-svg-icons';
import { Grid, GridColumn as Column, GridNoRecords, GridToolbar } from '@progress/kendo-react-grid';
import { Link as MuiLink } from '@mui/material';
import { Link as RouterLink, useLoaderData, useNavigate } from 'react-router-dom';
import { Button } from '@progress/kendo-react-buttons';

export type UsersResponse = {
  Users: CarrierUser[];
  ContactTypes: ContactType[];
}

export type ContactType = {
  ID: number;
  Name: string;
}

export type CarrierUser = {
  CarrierContactID: number;
  FirstName: string;
  LastName: string;
  FullName: string;
  EMailAddress: string;
  PhoneNumber: string;
  PhoneNumberFormatted: string;
  PhoneNumberExtension: string;
  Title: string;
  ContactType: number;
  ContactTypeName: string;
  SendTruckAvailability: boolean;
  SendOfferCancellations: boolean;
  IsSelf: boolean;
}

const Users = () => {
  const data = useLoaderData() as UsersResponse;
  const navigate = useNavigate();

  return <Grid scrollable="none" data={data.Users} size='small'>
    <GridToolbar>
      <Button
        svgIcon={plusIcon}
        themeColor="primary"
        onClick={() => navigate('/users/new')}
      >
        Add User
      </Button>
    </GridToolbar>
    <GridNoRecords>
      No users setup.
    </GridNoRecords>
    <Column field="FullName" title="Name" cells={{ data: (props) => {
      const user = props.dataItem as CarrierUser;
      return <td {...props.tdProps}>
        <MuiLink component={RouterLink} to={`/users/${user.CarrierContactID}`} underline="hover">
          {user.FullName || user.EMailAddress}
        </MuiLink>
        {user.IsSelf && ' (you)'}
      </td>;
    } }} />
    <Column field="EMailAddress" title="Email" />
    <Column field="Title" title="Title" />
    <Column field="ContactTypeName" title="Contact Type" />
    <Column field="PhoneNumberFormatted" title="Phone" cells={{ data: (props) => {
      const user = props.dataItem as CarrierUser;
      return <td {...props.tdProps}>
        {user.PhoneNumberFormatted}{user.PhoneNumberExtension && ` x${user.PhoneNumberExtension}`}
      </td>;
    } }} />
  </Grid>;
}

export default Users;
